export default __webpack_public_path__ + "static/media/Text-field-(2).239c24eb.png";